import { FlagBannerFold } from "@phosphor-icons/react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import { SubscriptionPlanIcon } from "features/subscriptions/components";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { PLAN_SETTINGS_BACKGROUNDS } from "../../constants";

export default function LifetimeDealCard() {
  const isDesktop = useTwBreakpoint("lg");
  const { role } = useSelectedWorkspaceContext();

  const isOwner = role === "owner";

  return (
    <section
      className={clsx(
        "w-full gap-x-2 p-1.5 bg-white bg-cover bg-center rounded-5xl border border-black-200",
        PLAN_SETTINGS_BACKGROUNDS.outreach,
      )}
    >
      <div className="flex flex-col gap-6 p-5">
        <div className="flex flex-row items-center justify-between gap-3">
          <div className="flex flex-row items-center gap-3">
            <SubscriptionPlanIcon plan="user" size="sm" />
            <span className="text-lg-bold">Outreach Plan</span>
          </div>

          <Tag
            variant="tertiary"
            size="md"
            leftIcon={<FlagBannerFold weight="fill" className="size-4" />}
          >
            Lifetime seats
          </Tag>
        </div>

        <div className="flex gap-4 justify-between w-full items-end">
          <p className="text-xs-medium max-w-85">
            This workspace uses Lifetime seats from Life time seats plan. A
            single workspace can either have a paid Outreach subscription, or
            use Lifetime seats.
            {/* Show this for owners only */}
            <RenderIf condition={!isOwner}>
              <br />
              <span>Contact your admin to manage seats.</span>
            </RenderIf>
          </p>

          <RenderIf condition={isOwner}>
            {/* TODO: Multi-step button - Add Remove Seats option */}
            <Button size={isDesktop ? "sm" : "md"} asChild>
              <Link to="../ltd">Go to Lifetime seats page</Link>
            </Button>
          </RenderIf>
        </div>
      </div>
    </section>
  );
}
